export default function (app) {
    app.constant('userRolesObject', {
        admin: 'Admin',
        operator: 'Operator',
        teamLead: 'TeamLead',
        rrd: 'RRD',
        accountAdmin: 'AccountAdmin',
        tradeInvestigations: 'TradeInvestigations'
    });
}



// WEBPACK FOOTER //
// ./Client/app/common/constants/userRolesObject.js